module.exports = {
  realm: 'UK',
  market: 'en-GB',
  domain: 'weightwatchers.co.uk',
  countryId: '5000',
  vsPath: 'uk',
  spiceLocale: 'uk',
  vsUrl: 'https://www{env}weightwatchers.com/uk',
  spiceUrl: 'https://www{env}weightwatchers.com/assets/cmx/uk/messages/',
  cmxSiteUrl: 'https://cmx{env}weightwatchers.co.uk/',
  currency: '£',
  decimalSeparator: '.',
  thousandSeparator: ',',
  currencyFormat: '£%number',
  dateFormat: 'dd/MM/yyyy',
  loginApiUrl: 'https://auth{env}weightwatchers.co.uk/login-apis/',
  loginWebUrl: 'https://auth{env}weightwatchers.co.uk/v2/login/',
  countryCode: 'GB',
  commUlr: 'https://commerce{env}weightwatchers.com/gb/en/api/',
  timezone1: 'Europe/London',
  timezone2: '+00:00',
};
